import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { Autocomplete,createFilterOptions } from '@material-ui/lab';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import {
  DB_YEAR_MONTH,
  DISPLAY_YEAR_MONTH
} from '../../../redux/constants';
import moment from 'moment';
import {
    Container,
    Grid,
    Checkbox,
    MenuItem,
    InputLabel,
    Select,
    FormControlLabel,
    FormControl,
    Button,
    TextField,
  } from '@material-ui/core';
  import { getProjectList} from '../../../redux/projects/projectsActions';
  import {getClientManagers, getOnboardingTypes} from '../../../redux/appUsers/appUserActions';
  import {getInvoiceReport} from '../../../redux/invoiceReports/invoiceAction'
  import { notify } from '../../../redux/utils/notifications/notifications';
import { useStyles } from '../adminStyles';
const InvoiceReports = props => {
    document.title = 'Sciata Projects';
    const { btnMobile2, gridElRight, gridElLeft, btnMobile, inputMobile } = useStyles();
    const dispatch = useDispatch();
    const projectsList = useSelector(state => state.projects.allProjects || []);
    const [clientManagers, setClientManagers]=useState([]);
    const [milestones,setMilestones]=useState([]);
    const [searchObject,setSearchObject]=useState({
      projectId:0,
      milestoneRecId:0,
      yearMonth:moment(),
      cmId:0,
      onboardingTypeId:0
    });
    const [inputValue, setInputValue] = React.useState('');
    const [docType, setDocType] = React.useState('pdf');
    const [onboardingTypes,setOnboardingTypes]=useState([]);
    useEffect(() => {
      bindProjects(); 
      bindClientManagers();
      bindOnboardingTypes();       
      }, []);
      const bindProjects = () => dispatch(getProjectList());
      const bindClientManagers= async()=>{
        let _clientManagers = await dispatch(getClientManagers());
        setClientManagers(_clientManagers);
      }
      const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: option => (option.projectName+" "+option.client),
      });
      const bindOnboardingTypes= async()=>{
        let _types = await dispatch(getOnboardingTypes());
        setOnboardingTypes(_types);
      }
      const handleGo=async()=>{
        if((searchObject.projectId||0)==0){
          notify('alert',`${'Plesae select project'}`);
        }else{
        try{
          const resp=await dispatch(getInvoiceReport(searchObject,docType));
          if(resp.status===200){
            if(docType=='pdf')
            await showFile(resp.data,'invoice details.pdf');
            else{
              await downloadBlob(resp.data,'invoice details.xls');
            }
           notify('success',`${'Invoice report downloaded successfully'}`);
          }else{
            notify('error',`${resp.data.error}`);
          }
          setSearchObject({projectId:0,
            milestoneRecId:0,
            yearMonth:moment(),
            cmId:0,
            onboardingTypeId:0});
            setInputValue('');
        }catch(ex){
        }
      }
      }
      const showFile=(blob,fileName)=>{
        var newBlob = new Blob([blob], {type: "application/pdf"})
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob,fileName+'.pdf');
          return;
        } 
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', fileName+'.pdf');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(blobURL);
        }, 100);
      
  
        setTimeout(function(){
        }
        , 100);
      }
      const downloadBlob=(blob, name = 'invoice.xls')=> {
        // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
        const blobUrl = URL.createObjectURL(new Blob([blob]));      
        // Create a link element
        const link = document.createElement("a");      
        // Set link's href to point to the Blob URL
        link.href = blobUrl;
        link.download = name;      
        // Append link to the body
        document.body.appendChild(link);      
        // Dispatch click event on the link
        // This is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
          new MouseEvent('click', { 
            bubbles: true, 
            cancelable: true, 
            view: window 
          })
        );      
        // Remove link from body
        document.body.removeChild(link);
      }
    return (
            
            <Grid container justify='center' alignItems='center' spacing={1}>
              <Grid item xs={10}>
                <h1>Invoice Reports</h1>
                
              </Grid>
                <Grid item xs={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={docType === 'pdf' ? true : false}
                      name='active'
                      onChange={e => {
                        let doc = (docType=='pdf' ? 'xlx' : 'pdf');
                        setDocType(doc);
                      }}
                      color='primary'
                    />
                  }
                  label={"PDF"}
                />
              </Grid>
                <Grid item xs={3} >
                  <Autocomplete
                    onChange={(event, newValue) => {
                      searchObject.projectId=newValue==null?"":newValue.projectId;
                      setMilestones(((newValue||{}).milestones||[]));
                      setSearchObject(searchObject);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(newInputValue);
                    }}
                    filterOptions={filterOptions}
                    id="controllable-states-demo"
                    getOptionLabel={(option) => (option.client||"")==""?(option.projectName||""):(option.projectName||"")+"["+(option.client||"")+"]"}
                    options={projectsList}
                    style={{ width: '100%' }}
                    renderInput={(params) => <TextField {...params} label="Project" variant="outlined" />}
                  />

                </Grid>
                <Grid item xs={2} >
                  <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel variant='outlined' id='select-label-milestoneRecId'>
                    Milestone
                    </InputLabel>
                    <Select  style={{width:'100%'}}
                    labelId='select-label-milestoneRecId' 
                      name="milestoneRecId"
                      variant='outlined'
                      label='Milestone'
                      value={searchObject.milestoneRecId}
                      onChange={(e)=>{
                        searchObject.milestoneRecId=e.target.value;
                        setSearchObject({...searchObject});
                      }}>
                      <MenuItem value={0}>All</MenuItem>
                      {
                        milestones.map((item,k)=>{
                          return <MenuItem key={k} value={item.id}>{`${item.milestoneId} ${item.descreption}`}</MenuItem>
                        })
                      }
                    </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel variant='outlined' id='select-label-cmId'>
                    Client Manager
                    </InputLabel>
                  <Select style={{width:'100%'}}
                    labelId="select-label-cmId"
                      label='Client Manager'
                      name='cmId'
                      variant='outlined'
                      value={searchObject.cmId || 0}
                      id='clientmanager'
                      onChange={(e)=>{
                        searchObject.cmId=e.target.value;
                        setSearchObject({...searchObject});
                      }}
                    ><MenuItem value={0}>All</MenuItem>
                      {
                      clientManagers.map(manager => (
                         <MenuItem value={manager.id}>{`${manager.name}`}</MenuItem>
                      ))
                      }
                    </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel variant='outlined' id='select-label-onboardingTypeId'>
                    Onboarding Type
                    </InputLabel>
                    <Select style={{width:'100%'}}
                      labelId='select-label-onboardingTypeId'
                      label='Onboarding Types'
                      name='onboardingTypeId'
                      variant='outlined'
                      value={searchObject.onboardingTypeId || 0}
                      id='onboardingTypeId'
                      onChange={(e)=>{
                        searchObject.onboardingTypeId=e.target.value;
                        setSearchObject({...searchObject});
                      }}
                    >
                      <MenuItem value={0}>All</MenuItem>
                      {
                        onboardingTypes.map((item,k)=>{
                          return <MenuItem key={k} value={item.id}>{item.name}</MenuItem>
                        })
                      }                      
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      variant='inline'
                      inputVariant='outlined'
                      views={["year", "month"]}
                      className={inputMobile}
                      format={DISPLAY_YEAR_MONTH.replace('DD', 'dd').replace('YYYY', 'yyyy')}
                      id='date-picker-inline'
                      label='Year Month'
                      value={searchObject.yearMonth?moment(searchObject.yearMonth):null}
                      autoOk={true}
                      onChange={date => {
                        searchObject.yearMonth=moment(date).isValid()?date:null;
                        setSearchObject({...searchObject});
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid xs={12} item container
                  direction="row"
                  justify="center"
                  alignItems="center">
                <Button variant='contained'
                  color='secondary'
                  style={{ marginRight: '10px' }} onClick={()=>{
                    setInputValue('');
                  setSearchObject({
                    projectId:0,
                    milestoneRecId:0,
                    yearMonth:moment(),
                    cmId:0,
                    onboardingTypeId:0})
                }} variant='contained'>
                  Clear
                </Button>
                <Button className={btnMobile2} onClick={handleGo} variant='contained'>
                  Go
                </Button>
                </Grid>          
            </Grid>
        )
}
export default withRouter(InvoiceReports);